import { render } from "./Contacts.vue?vue&type=template&id=04121cea"
import script from "./Contacts.vue?vue&type=script&lang=js"
export * from "./Contacts.vue?vue&type=script&lang=js"
script.render = render

export default script